import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toLocal',
    pure: true,
    standalone: false
})
export class ToLocalStringPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return '0';
    }
    if(isNaN(value)){
      return value;
    }   

    return (+value).toLocaleString('sv');
  }
}
